// Module
var code = "<div class=\"row\"> <div class=\"col-12 mb-2\" id=\"budget\"> <div><span id=\"budget-slider-output\">500 000</span> €</div> <input type=\"range\" class=\"form-range col-4\" min=\"0\" max=\"1000000\" step=\"10000\" id=\"budget-slider\"> <button id=\"budget-validator\" class=\"btn btn-primary mb-2\">Confirmer</button> </div> </div> ";
// Exports
module.exports = code;